import React from 'react'
import CommonSectionTitle from '../../App/Components/CommonSectionTitle'
import { iHome } from '../../utilities/ImageImports'
import { GroundMapper } from '../components/GroundMapper'
import PlayTitle from '../components/PlayTitle'

const GroundZeroList = () => {
    return (
        <div className=''>
            <CommonSectionTitle
                title='Ground Zero (Home)'
                titleIcon={iHome}
            />
            <div className='grid xl:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-3 pt-5 ' >
                {GroundMapper?.map((item, index) =>
                    index > 0 ?
                        <PlayTitle
                            capsule={true}
                            key={index}
                            title={item?.title}
                            subtitle={item?.subtitle}
                            linkTo={item?.linkTo}
                        /> : ""
                )}
            </div>
        </div>
    )
}

export default GroundZeroList
